import unitless from '@emotion/unitless';
import type { CSSObject, Transformer } from 'ant-design-vue';
import { CacheManager } from './cache';

/** UI基准尺寸 */
const UI_WIDTH = 1280;
const UI_HEIGHT = 800;
export const UI_RATIO = {
  W: window.innerWidth / UI_WIDTH,
  H: window.innerHeight / UI_HEIGHT,
};

const FACTOR = Math.pow(10, 4);
const toVW = (number: number) => Math.round(number * FACTOR) / FACTOR;

/** @deprecated 建议使用adaptiveSize方法 像素转视口宽，基于UI标准 */
export const px2vw = (pixels: number) => `${toVW(pixels)}vw`;

/** @deprecated 建议使用adaptiveSize方法 根据设备实际宽度计算px */
export const adaptiveByVW = (pixels: number) => UI_RATIO.W * pixels;

/** @deprecated 建议使用adaptiveSize方法 根据设备实际高度计算px */
export const adaptiveByVH = (pixels: number) => UI_RATIO.H * pixels;

export const px2vwTransformer = (): Transformer => {
  const factor = 100 / UI_WIDTH;
  const pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
  const pxReplace = (m: string, $1: string) => {
    if (!$1) return m;

    const pixels = parseFloat($1);
    return pixels <= 1 ? m : `${toVW(pixels * factor)}vw`;
  };

  const cacheManager = new CacheManager();
  const unitlessSet = new Set(Object.keys(unitless));
  const visit = (cssObj: CSSObject): CSSObject => {
    const changed: CSSObject = {};
    let hasChanges = false;

    for (const [key, value] of Object.entries(cssObj)) {
      if (typeof value === 'string' && value.includes('px')) {
        const cached = cacheManager.get(value);
        let newValue = cached?.v;
        if (!newValue) {
          newValue = value.replace(pxRegex, pxReplace);
          cacheManager.set(value, newValue);
        }

        if (newValue !== value) {
          changed[key] = newValue;
          hasChanges = true;
        }
      }

      // no unit
      if (typeof value === 'number' && value !== 0 && !unitlessSet.has(key)) {
        changed[key] = `${toVW(value * factor)}vw`;
        hasChanges = true;
      }
    }

    return hasChanges ? { ...cssObj, ...changed } : cssObj;
  };

  return { visit };
};
